import {generateCallback} from '../util/appCallback';

// 获取指定 key 对应的客户端本地数据
export function getStorage(option) {
    if (this.mGetStorage && option.key) {
        const globalMethodName = generateCallback(option, val => {
            return {
                code: 0,
                data: {
                    value: val
                }
            };
        });
        this.mGetStorage({
            key: option.key || '',
            callback: globalMethodName
        });
    }
}
// 存储键名、值到到客户端本地数据
export function setStorage(option) {
    if (this.mSetStorage && option.key) {
        const globalMethodName = generateCallback(option, obj => {
            return {
                code: 0,
                data: obj.data
            };
        });
        this.mSetStorage({
            key: option.key || '',
            val: option.val || '',
            callback: globalMethodName
        });
    }
}

export default {
    getStorage,
    setStorage
};
